import React, { useEffect, useContext, useState } from 'react'
import Swiper from 'swiper'
import { motion } from "framer-motion"

import Card from './Card'
import waiter from '../assets/img/waiter.svg'
import plate from '../assets/icons/plate.svg'

import MyContext from "./Context/Context";
import { transitionPages } from "./utils/animations"
import Popup from './Popup'


function Main() {
    const { data, filterPizzas } = useContext(MyContext);
    const [ search, setSearch ] = useState("");
    const [ swipper, setSwipper ] = useState(null);
    const [ popup, setPopup ] = useState({
        isOpen: false,
        id: null
    });

    useEffect(() => {
        const swip = new Swiper(".swiper-container", {
            slidesPerView: 5,

          });
          setSwipper(swip)

          return () => {
              swip.destroy();
          }
    }, [])

    const handleSearch = (e) => {
        if(e.target.value.length >= 0) {
            setSearch(e.target.value);
            filterPizzas(e.target.value);
        }
        swipper.slideTo(0); 
    }

    const variantsList ={
        hidden: {
          opacity: 0
        },
        show: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2
          }
        }
      }

    const variantsList2 ={
        hidden: {
          opacity: 0,
        },
        show: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2,
            delayChildren: 1.2,
          }
        }
      }

      const item = {
        hidden: { opacity: 0, y: -50 },
        show: { opacity: 1, y: 0 },
        transition: { ease: "easeInOut" },
      };

      const displayPopupPizza = (id) => {
          setPopup(state => {
            return { ...state, isOpen: !state.isOpen, id: id }
          });
      }

    return (
        <motion.main 
        initial={transitionPages.initial}
        exit={transitionPages.exit}
        animate={transitionPages.animate}
        transition={transitionPages.transition}
        className="main">
            <div className="main__container">
                {
                    popup.isOpen && (<Popup displayPopupPizza={displayPopupPizza} id={popup.id} />)
                }
                <div className="main__search">
                    <div className="main__search__input">
                        <label htmlFor="search">
                            <input onChange={(e) => handleSearch(e)} value={search} id="search" type="text" placeholder="Search a pizza"/>
                        </label>
                    </div>
                    <span>{new Date().toDateString()}</span>
                </div>
                <section className="offer">
                    <p>Get free <span className="bold">one large pizza </span>and <span className="bold">one large fountain drink</span> everytime you order over $30 or buy 2 larges pizza</p>
                    <img src={waiter} alt="waiter"/>
                </section>
                <section className="popular">
                    <h2 className="popular__title">
                        <span className="bold">Popular</span> this week
                    </h2>
                    <div className="swiper-container">
                        <motion.ul 
                        variants={variantsList}
                        initial="hidden"
                        animate="show"
                        className="swiper-wrapper popular__list">
                            {
                                data.map(item => (
                                    <Card key={item.id} data={item} displayPopupPizza={displayPopupPizza} />
                                ))
                            }
                        </motion.ul>
                    </div>
                </section>
                <section className="popular">
                    <h2 className="popular__title">
                        <span className="bold">Favourite </span> restaurants
                    </h2>
                    <motion.ul 
                    variants={variantsList2}
                    initial="hidden"
                    animate="show"
                    className="popular__restaurants">
                        <motion.li
                            variants={item}
                        >
                            <img src={plate} alt="plate"/>
                            <div className="popular__restaurants__desc">
                                <p>Tenderloin</p>
                                <p>1065 Avenue of the Americas, New York, NY</p>
                            </div>
                        </motion.li>
                        <motion.li
                            variants={item}
                        >
                            <img src={plate} alt="plate"/>
                            <div className="popular__restaurants__desc">
                                <p>Amma</p>
                                <p>246 E 51st St Frnt 2, New York, NY</p>
                            </div>
                        </motion.li>
                        <motion.li
                            variants={item}
                        >
                            <img src={plate} alt="plate"/>
                            <div className="popular__restaurants__desc">
                                <p>ICHIRAN</p>
                                <p>152 West 49th Street, New York, NY</p>
                            </div>
                        </motion.li>
                    </motion.ul>
                </section>
            </div>
        </motion.main>
    )
}

export default Main
